import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSend = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 14,
	viewBox: "0 0 15 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M14.75 7C14.7498 7.13464 14.7135 7.26676 14.6446 7.38249C14.5758 7.49822 14.4771 7.59329 14.3589 7.65771L3.9014 13.6343L3.8999 13.6328C3.7803 13.7089 3.6417 13.7495 3.5 13.75C3.3011 13.75 3.1103 13.671 2.9697 13.5303C2.829 13.3897 2.75 13.1989 2.75 13V8.5L11 7L2.75 5.5V1C2.75 0.801088 2.829 0.610322 2.9697 0.46967C3.1103 0.329018 3.3011 0.25 3.5 0.25C3.642 0.250198 3.7812 0.289902 3.9014 0.365723L14.3398 6.33203C14.4632 6.39471 14.5667 6.49028 14.6391 6.60817C14.7115 6.72606 14.7499 6.86166 14.75 7ZM2.75 5.5V8.5L0.795898 7.48486C0.403613 7.28086 0.403613 6.71985 0.795898 6.5166L2.75 5.5Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgSend);
export { ForwardRef as ReactComponent };
